<template>
  <BaseModal
    :id="`ModalCriterion`"
    title="Add an additional assessment criterion"
    :hide-footer="true"
    :size="'xl'"
    @closeModal="closeModal"
    @openModal="openModal"
  >
    <div class="mb-4">
      <label for="textarea-title">Assessment criterion</label>
      <b-form-textarea
        id="input-assessment-criterion"
        v-model="$v.form.description.$model"
        class="mt-2"
        rows="3"
        placeholder="Describe your assessment criterion"
        :class="{
          'is-invalid': $v.form.description.$error,
          'is-valid': !$v.form.description.$invalid
        }"
      />
      <b-form-invalid-feedback v-if="!$v.form.description.required">
        Assessment criterion is required.
      </b-form-invalid-feedback>
    </div>

    <div class="mb-4 ml-4">
      <label for="textarea-title">Definition of "Pass"</label>
      <b-form-textarea
        id="input-definition-of-pass"
        v-model="$v.form.pass_criterion.$model"
        class="mt-2"
        rows="3"
        placeholder='Describe your definition of "Pass"'
        :class="{
          'is-invalid': $v.form.pass_criterion.$error,
          'is-valid': !$v.form.pass_criterion.$invalid
        }"
      />
      <b-form-invalid-feedback v-if="!$v.form.pass_criterion.required">
        Definition of "Pass" is required.
      </b-form-invalid-feedback>
    </div>

    <div class="mb-4 ml-4">
      <label for="textarea-title">Definition of "Not yet"</label>
      <b-form-textarea
        id="input-definition-of-not-yet"
        v-model="$v.form.not_yet_criterion.$model"
        class="mt-2"
        rows="3"
        placeholder='Describe your definition of "Not yet"'
        :class="{
          'is-invalid': $v.form.not_yet_criterion.$error,
          'is-valid': !$v.form.not_yet_criterion.$invalid
        }"
      />
      <b-form-invalid-feedback v-if="!$v.form.not_yet_criterion.required">
        Definition of "Not yet" is required.
      </b-form-invalid-feedback>
    </div>

    <div class="d-flex justify-content-start border-top pt-4">
      <b-button id="button-add" variant="success" @click="handleCriterion">
        {{ isEdit ? 'Save' : 'Add' }}
      </b-button>
      <b-button id="button-cancel" variant="link" class="btn-link-dark" @click="hide()">
        Cancel
      </b-button>
    </div>
  </BaseModal>
</template>

<script>
import { BaseModal } from '@/components/base-components';
import { notificationMixin } from '@/mixins';
import { validationMixin } from 'vuelidate';
import { required } from 'vuelidate/lib/validators';

export default {
  name: 'ModalCriterion',

  components: {
    BaseModal
  },

  mixins: [notificationMixin, validationMixin],

  props: {
    formEditCriterion: {
      type: Object,
      default: () => ({})
    },
    criterionIndex: {
      type: Number,
      default: -1
    },
    listCriterion: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      form: {
        description: '',
        pass_criterion: '',
        not_yet_criterion: ''
      }
    };
  },

  computed: {
    isEdit() {
      if (Object.keys(this.formEditCriterion).length) return true;
      else return false;
    }
  },

  watch: {
    isEdit: {
      immediate: true,
      handler() {
        if (this.isEdit === true) {
          this.form = { ...this.formEditCriterion };
        } else {
          this.resetForm();
        }
      }
    }
  },

  validations() {
    return {
      form: {
        description: { required },
        pass_criterion: { required },
        not_yet_criterion: { required }
      }
    };
  },

  methods: {
    handleCriterion() {
      this.$v.form.$touch();
      if (this.$v.form.$anyError) return;
      if (this.isEdit === true) {
        this.listCriterion[this.criterionIndex] = this.form;
      } else {
        this.$emit('addCriterion', this.form);
      }

      this.resetForm();
      this.hide();
    },
    closeModal() {
      this.$emit('closeModal', true);
    },
    openModal() {
      this.$emit('openModal', true);
    },
    show(type) {
      this.modalType = type;
      this.$bvModal.show(`ModalCriterion`);
    },
    hide() {
      this.$bvModal.hide(`ModalCriterion`);
      this.resetForm();
    },
    resetForm() {
      this.form = {
        description: '',
        pass_criterion: '',
        not_yet_criterion: ''
      };
      this.$v.$reset();
    }
  }
};
</script>

<style lang="scss" scoped></style>
